// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SpeakerVolumeMediumIconSignature {
  Element: SVGSVGElement;
}

export const SpeakerVolumeMediumIcon: TOC<SpeakerVolumeMediumIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13 22C12.433 22 11.89 21.776 11.474 21.28L8.479 17H6C4.897 17 4 16.103 4 15V11C4 9.89801 4.897 9.00001 6 9.00001H8.479L11.586 4.58601C12.149 4.02201 13.025 3.84701 13.764 4.15201C14.515 4.46201 15 5.18701 15 6.00001V20C15 20.813 14.515 21.54 13.764 21.849C13.521 21.949 13.263 22 13 22ZM6 11V15H9.521L13.001 19.976L13 6.02701L9.521 11H6ZM18 13C18 13.552 17.551 14 17 14V16C18.654 16 20 14.654 20 13C20 11.346 18.654 10 17 10V12C17.551 12 18 12.449 18 13Z"/>
</svg>
</template>;